<div class="text text_bigger" mat-dialog-content>
    Доступна новая версия. Обновите приложение перед началом работы
</div>
<div class="dialog-action-right" mat-dialog-actions>
    <button color="primary" mat-raised-button (click)="goToStore()">Обновить</button>
</div>


